type IsRegressionTestOptions = {
  clientId?: string;
  projectId?: string;
};

/**
 * Returns true when the component is being rendered by a visual regression
 * test runner (currently Percy). Use this to suppress timers, loaders, or
 * any other time-sensitive state so snapshots are always deterministic.
 *
 * Pass whichever ID your package exposes — clientId (most packages) or
 * projectId (identity-navigation).
 */
export function isRegressionTest({ clientId, projectId }: IsRegressionTestOptions = {}): boolean {
  return clientId === 'percy' || projectId === 'percy';
}
